<template>
  <!-- 下单有礼 复购 shougou -->
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <div class="card-point">
          <div class="card-rule">
            <i
              class="el-alert__icon el-icon-info"
              style="color: #2670fb; margin-right: 3px"
            ></i>
            注意：
          </div>
          <!-- <template v-if="venderType">
            <div class="card-connet" v-if="orderCRM">
              <p>
                1、自营店铺需要搭配<span style="color:#FE4D45;">云短信CRM</span>使用,<span
                  style="color:#FE4D45;"
                  @click="handleCreate"
                  class="pointer"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
            <div class="card-connet" v-else>
              <p>
                1、云短信CRM：订购到期时间 {{ orderCRMtime }}（自营店铺需要搭配<span @click="handleCreate" class="pointer" style="color:#FE4D45;"
                  >云短信CRM</span
                >使用）。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
          </template> -->
          <div class="card-connet" style="margin-left: -30px">
            <p>
              为避免客诉，参与活动用户达到参与规则订单条件即可领取奖品，但在订单完成后才可发放奖品
            </p>
          </div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="155px"
        >
          <!-- 下单有礼 -->
          <template>
            <el-form-item label="活动名称:" required>
              <!-- prop="activityName" 活动名称 -->
              <el-input
                v-model="ruleForm.activityName"
                maxlength="50"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 340px"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
              <div class="my_select_time">
                <el-date-picker
                  v-model="activityTimeValue"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange"
                  style="width: 340px; font-size: 12px"
                  :picker-options="pickerOptionsValue"
                  :default-time="defaultTime"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="activityTimeValue = []"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
                <span style="color: #2670fb">{{ timeOut }}</span> 小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动有效期不可超过订购有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
            <el-form-item label="活动对象：" required>
              <el-radio-group
                v-model="ruleForm.activityObject"
                :disabled="isStartEdit"
                @change="handleActivityObj"
                style="margin-right: 16px"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">指定身份</el-radio>
                <el-radio :label="2" :disabled="true">指定人群</el-radio>
              </el-radio-group>
              <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button slot="reference" :disabled="true">{{
                  peopleList.length == 0
                    ? "选择人群"
                    : `已选${peopleList.length}个`
                }}</el-button>
              </el-popover>
            </el-form-item>
            <el-form-item
              label="新老客户："
              required
              v-if="ruleForm.activityObject == '1'"
            >
              <el-radio-group
                v-model="ruleForm.newOldCustomer"
                :disabled="isStartEdit"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">新客</el-radio>
                <el-radio :label="2">老客</el-radio>
              </el-radio-group>
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content">
                  1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
                </div>
                <div
                  class="cursorPointer"
                  style="
                    display: inline-block;
                    margin-left: 16px;
                    font-size: 12px;
                    color: #999;
                  "
                >
                  <span>新老客说明</span>
                  <i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              label="参与对象:"
              prop="partner"
              v-if="ruleForm.activityObject == '1'"
            >
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="isStartEdit"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >

                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="
              isStartEdit
            "
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
            <el-form-item label="活动条件:">
              <el-checkbox v-model="ruleForm.condFollow" :disabled="isStartEdit"
                >关注店铺后方可参与活动</el-checkbox
              ></el-form-item
            >
            <el-form-item
              v-if="activityData.id != 16"
              :label="activityData.id == 18 ? '复购规则:' : '首购规则:'"
              required
            >
              近&nbsp;<el-input
                @input="ruleForm.days = getNumberData($event, 0)"
                style="width: 140px"
                v-model="ruleForm.days"
                placeholder="请输入"
                @change="changDays()"
                :disabled="isStartEdit"
              ></el-input
              >&nbsp; 天内<span v-if="activityData.id == 17">未购</span
              ><span v-if="activityData.id == 18">已购</span>
              <el-tooltip effect="light" placement="bottom">
                <div slot="content">
                  1、最大时间建议不超过90天；<br />2、从活动设置的下单开始时间往前算近{{
                    ruleForm.days
                  }}天（包括下单开始时间）
                </div>
                <el-button type="text" style="margin-left: 6px; width: 35px">
                  <i class="el-icon-question icon-top" style="color: #ccc"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="参与规则与奖品设置:" required>
              <span>参与活动用户在订单完成后才可发放奖品</span>
              <div style="margin: 10px 0">
                <el-radio-group
                  v-model="ruleForm.prizeRule"
                  v-if="activityData.id !== 17"
                  :disabled="isStartEdit"
                >
                  <el-radio :label="0">统一奖品</el-radio>
                  <el-radio :label="1">阶梯奖品</el-radio>
                </el-radio-group>
              </div>
              <div v-if="ruleForm.prizeRule == 1 && activityData.id !== 17">
                <span style="color: red"
                  >注意：该订单金额为实付金额；当满足多个阶梯条件时，可任选其中一个奖品，但只能领取1次奖品。</span
                >
              </div>
              <div class="rule_box">
                <div class="rule_box_top">所下订单需满足如下条件</div>
                <div class="rule_box_middle">
                  <!-- 淘宝3.36 -->
                  <el-form-item
                    label="订单统计方式:"
                    v-if="ruleForm.prizeRule == 0"
                  >
                    <el-radio-group
                      v-model="ruleForm.orderStatType"
                      :disabled="isStartEdit"
                    >
                      <el-radio :label="0">单笔订单</el-radio>
                      <el-radio :label="1"
                         :disabled="openExtraOrder"
                        >累计订单
                        <el-tooltip
                          class="custom"
                          effect="light"
                          content="累计订单：多笔订单相加符合商品件数、订单金额即中奖
                                   单笔订单：单笔订单符合商品件数、订单金额即中奖"
                          placement="bottom"
                          popper-class = 'custom'
                        >
                        <div slot="content">累计订单：多笔订单相加符合商品件数、订单金额即中奖</div>
                        <div slot="content">单笔订单：单笔订单符合商品件数、订单金额即中奖</div>
                          <el-button
                            type="text"
                            style="width: 35px; margin-left: -12px"
                          >
                            <i class="el-icon-question" style="color: #ccc"></i>
                          </el-button>
                        </el-tooltip>
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    label="订单状态:"
                    v-if="ruleForm.prizeRule == 0"
                  >
                    <el-select
                      size="small"
                      v-model="ruleForm.unlockTradeStatus"
                      style="width: 280px"
                      :disabled="isStartEdit"
                    >
                      <el-option
                        v-for="(item, index) in dataFromList"
                        :key="index"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                    <div style="color: #f59a22">注意：</div>
                    <div style="color: #f59a22">
                      付尾款或付款：统计下单时间内已付款（包括完成）的订单（预售商品需要支付尾款才可参与活动）
                    </div>
                    <div style="color: #f59a22">
                      收货：只统计下单时间内已收货完成的订单（下单时间在指定时间，收货时间不受时间限制）
                    </div>
                  </el-form-item>

                <el-form-item
                label="领奖时间:"
                v-if="ruleForm.prizeRule == 0 && ruleForm.unlockTradeStatus == '1'"
              >
                <div style="display: flex;">
                  确认收货&nbsp;
                  <el-input
                    v-model="ruleForm.joinDay"
                    placeholder="请输入"
                    type="number"
                     style="width: 140px"
                    :disabled="isStartEdit"
                  ></el-input>
                  &nbsp;天后可领取
                </div>
                <div style="color: #f59a22">
                  注:不填代表用户一确认收货就可以领取奖品
                </div>
              </el-form-item>



                  <!-- end -->
                  <el-form-item label="下单时间:" required>
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                        :disabled="isStartEdit"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                        :disabled="isStartEdit"
                      >
                      </el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                  </el-form-item>
                </div>
                <div class="rule_box_bottom zindexBox">
                  <el-form-item label="指定购买商品:" required>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="0"
                      :disabled="isStartEdit"
                      >全部商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="1"
                      :disabled="isStartEdit"
                      >指定商品</el-radio
                    >
                    <el-button
                      :disabled="
                        ruleForm.filterType == '0' ||
                        ruleForm.filterType == '2' ||
                        isStartEdit
                      "
                      :style="{
                        width: itemListForFilter.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="2"
                      style="margin-left: 30px"
                      :disabled="isStartEdit"
                      >排除商品</el-radio
                    >
                    <el-button
                      :disabled="
                        ruleForm.filterType == '0' ||
                        ruleForm.filterType == '1' ||
                        isStartEdit
                      "
                      :style="{
                        width: itemListForFilter1.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter1"
                    >
                      {{
                        itemListForFilter1.length != ""
                          ? "已选择" + "(" + itemListForFilter1.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <div style="color: #f59a22">
                      选择指定商品，用户订单中内有一件指定商品时则整笔计算
                    </div>
                    <div style="color: #f59a22">
                      选择排除商品，用户订单中全部为排除商品时订单将不计算；用户订单内有一件非排除商品时，只算非排除商品部分。
                    </div>
                  </el-form-item>
                </div>
                <template v-if="this.ruleForm.prizeRule == '0'">
                  <el-form-item label="商品件数:" required>
                    <el-input
                      v-model="ruleForm.orderStartCount"
                      @input="
                        ruleForm.orderStartCount = getNumberData($event, 0)
                      "
                      @change="changDays()"
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="isStartEdit"
                    ></el-input
                    >&nbsp; 件- &nbsp;
                    <el-input
                      v-model="ruleForm.orderEndCount"
                      @input="ruleForm.orderEndCount = getNumberData($event, 0)"
                      @change="changDays()"
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="isStartEdit"
                    ></el-input
                    >&nbsp; 件
                  </el-form-item>
                  <el-form-item label="订单金额:" required>
                    <el-input
                      v-model="ruleForm.orderStartPayment"
                      @input="
                        ruleForm.orderStartPayment = getNumberData($event, 1)
                      "
                      @change="changDays()"
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="isStartEdit"
                    ></el-input
                    >&nbsp; 元- &nbsp;
                    <el-input
                      v-model="ruleForm.orderEndPayment"
                      @input="
                        ruleForm.orderEndPayment = getNumberData($event, 1)
                      "
                      @change="changDays()"
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="isStartEdit"
                    ></el-input
                    >&nbsp; 元<span style="color: red; margin-left: 10px"
                      >注意：该订单金额为实付金额</span
                    >
                  </el-form-item>
                </template>
              </div>
              <template v-if="activityData.id == 17">
                <div class="prize_box">
                  <el-table
                    :header-cell-style="{
                      'text-align': 'center',
                      'border-bottom': '2px solid #EBEEF5',
                      background: '#F8F9FF',
                    }"
                    :cell-style="{
                      'text-align': 'center',
                      overflow: 'visible',
                    }"
                    :data="tableData"
                    border
                    style="width: 625px; overflow: visible"
                  >
                    <el-table-column prop="date" label="序号" width="110">
                      <template slot-scope="scope">
                        <!-- <el-input @keyup.native="limitInput($event)" v-model="scope.row.peopleCount"></el-input> -->
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="奖品类型">
                      <template slot-scope="scope">
                        <span
                          style="color: #2670fb; cursor: pointer"
                          v-if="
                            scope.row.prizeType == 3 ||
                            scope.row.prizeType == 10
                          "
                          @click="centerVis(scope)"
                          >{{ scope.row.title }}</span
                        >
                        <span
                          style="color: #2670fb; cursor: pointer"
                          v-else-if="scope.row.prizeType"
                          @click="centerVis(scope)"
                          >{{ scope.row.prizeType | prizeType }}</span
                        >
                        <span
                          v-else
                          @click="centerVis(scope)"
                          style="color: #2670fb; cursor: pointer"
                          >选择奖品</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          @blur="beAdd(scope.row)"
                          @input="
                            scope.row.prizeCount = getNumberData($event, 0)
                          "
                        ></el-input>
                        <div class="del_box">
                          <div class="delQx" @click="itemDel(scope.$index)">
                            <img src="@/assets/images/btn_del.svg" alt="" />
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div @click="addPrizeRule" class="add_btn1">
                    <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
                    添加奖项（{{ tableData.length }}/4）
                  </div>
                </div>
              </template>
              <template v-if="ruleForm.prizeRule == 0 && activityData.id != 17">
                <div>
                  <el-form-item label="开启双订单条件:">
                    <div class="flex-center">
                      <el-switch
                        class="tableScopeSwitch"
                        v-model="openExtraOrder"
                        active-color="#2670fb"
                        inactive-color="#dcdfe6"
                        active-text="已开启"
                        inactive-text="未开启"
                        :active-value="1"
                        :inactive-value="0"
                        :disabled="isStartEdit || ruleForm.orderStatType == 1"
                      >
                      </el-switch>
                      <el-tooltip
                        class="item"
                        effect="light"
                        content="开启双订单条件，则需要再原来的基础上配置第二个订单的条件，用户满足条件后才可获得奖品。注：当订单统计方式选中“累计订单”时，不支持开启双订单模式"
                        placement="bottom"
                      >
                        <el-button type="text" style="width: 35px">
                          <i class="el-icon-question" style="color: #ccc"></i>
                        </el-button>
                      </el-tooltip>
                    </div>
                  </el-form-item>
                  <template v-if="openExtraOrder == 1">
                    <el-form-item label="双订单规则:">
                      <el-select
                        v-model="extraOrderType"
                        placeholder="请选择"
                        :disabled="isStartEdit"
                      >
                        <el-option
                          v-for="item in ruleOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <div class="rule_box" style="padding-top: 16px">
                      <div></div>
                      <div class="rule_box_middle">
                        <el-form-item label="下单时间:" required>
                          <div class="my_select_time">
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="ruleExtraDTO.orderStartTime"
                              type="datetime"
                              placeholder="开始日期"
                              size="small"
                              format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              style="width: 190px; font-size: 12px"
                              default-time="00:00:00"
                              class="time1"
                              @change="orderChange"
                              :clearable="false"
                              :picker-options="pickerOrderStart1"
                              :disabled="isStartEdit"
                            >
                            </el-date-picker>
                            <div class="time_to_text">至</div>
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="ruleExtraDTO.orderEndTime"
                              type="datetime"
                              placeholder="结束日期"
                              size="small"
                              format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              style="width: 195px; font-size: 12px"
                              default-time="23:59:59"
                              class="time2"
                              @change="orderChange"
                              :clearable="false"
                              :picker-options="pickerOrderEnd1"
                              :disabled="isStartEdit"
                            >
                            </el-date-picker>
                            <i
                              class="el-icon-circle-close date_icon1"
                              @click="clearDoubleOrderTime()"
                            ></i>
                            <img
                              src="@/assets/images/select_date.svg"
                              alt=""
                              class="date_icon2"
                            />
                          </div>
                        </el-form-item>
                      </div>
                      <div class="rule_box_bottom zindexBox">
                        <el-form-item label="指定购买商品:" required>
                          <el-radio
                            v-model="ruleExtraDTO.filterType"
                            @change="filterTypeChange1"
                            label="0"
                            :disabled="isStartEdit"
                            >全部商品</el-radio
                          >
                          <el-radio
                            v-model="ruleExtraDTO.filterType"
                            @change="filterTypeChange1"
                            label="1"
                            :disabled="isStartEdit"
                            >指定商品</el-radio
                          >
                          <el-button
                            :disabled="
                              ruleExtraDTO.filterType == '0' ||
                              ruleExtraDTO.filterType == '2' ||
                              isStartEdit
                            "
                            :style="{
                              width:
                                itemListForFilter5.length > 0
                                  ? '110px'
                                  : '60px',
                            }"
                            @click="exposureProductsFiter5"
                          >
                            {{
                              itemListForFilter5.length != ""
                                ? "已选择" +
                                  "(" +
                                  itemListForFilter5.length +
                                  "个)"
                                : "+添加"
                            }}
                          </el-button>
                          <el-radio
                            v-model="ruleExtraDTO.filterType"
                            @change="filterTypeChange1"
                            label="2"
                            style="margin-left: 30px"
                            :disabled="isStartEdit"
                            >排除商品</el-radio
                          >
                          <el-button
                            :disabled="
                              ruleExtraDTO.filterType == '0' ||
                              ruleExtraDTO.filterType == '1' ||
                              isStartEdit
                            "
                            :style="{
                              width:
                                itemListForFilter6.length > 0
                                  ? '110px'
                                  : '60px',
                            }"
                            @click="exposureProductsFiter6"
                          >
                            {{
                              itemListForFilter6.length != ""
                                ? "已选择" +
                                  "(" +
                                  itemListForFilter6.length +
                                  "个)"
                                : "+添加"
                            }}
                          </el-button>
                          <div>
                            选择指定商品，用户订单中内有一件指定商品时则整笔计算
                          </div>
                          <div>
                            选择排除商品，用户订单中全部为排除商品时订单将不计算；用户订单内有一件非排除商品时，只算非排除商品部分。
                          </div>
                        </el-form-item>
                      </div>
                      <el-form-item label="商品件数:" required>
                        <el-input
                          v-model="ruleExtraDTO.orderStartCount"
                          @input="
                            ruleExtraDTO.orderStartCount = getNumberData(
                              $event,
                              0
                            )
                          "
                          @change="changDays2()"
                          style="width: 140px"
                          placeholder="请输入"
                          :disabled="isStartEdit"
                        ></el-input
                        >&nbsp; 件- &nbsp;
                        <el-input
                          v-model="ruleExtraDTO.orderEndCount"
                          @input="
                            ruleExtraDTO.orderEndCount = getNumberData(
                              $event,
                              0
                            )
                          "
                          @change="changDays2()"
                          style="width: 140px"
                          placeholder="请输入"
                          :disabled="isStartEdit"
                        ></el-input
                        >&nbsp; 件
                      </el-form-item>
                      <el-form-item label="订单金额:" required>
                        <el-input
                          v-model="ruleExtraDTO.orderStartPayment"
                          @input="
                            ruleExtraDTO.orderStartPayment = getNumberData(
                              $event,
                              1
                            )
                          "
                          @change="changDays2()"
                          style="width: 140px"
                          placeholder="请输入"
                          :disabled="isStartEdit"
                        ></el-input
                        >&nbsp; 元- &nbsp;
                        <el-input
                          v-model="ruleExtraDTO.orderEndPayment"
                          @input="
                            ruleExtraDTO.orderEndPayment = getNumberData(
                              $event,
                              1
                            )
                          "
                          @change="changDays2()"
                          style="width: 140px"
                          placeholder="请输入"
                          :disabled="isStartEdit"
                        ></el-input
                        >&nbsp; 元<span style="color: red; margin-left: 10px"
                          >注意：该订单金额为实付金额</span
                        >
                      </el-form-item>
                    </div>
                  </template>
                </div>

                <div class="prize_box">
                  <el-table
                    :header-cell-style="{
                      'text-align': 'center',
                      'border-bottom': '2px solid #EBEEF5',
                      background: '#F8F9FF',
                    }"
                    :cell-style="{
                      'text-align': 'center',
                      overflow: 'visible',
                    }"
                    :data="tableData"
                    border
                    style="width: 625px; overflow: visible"
                  >
                    <el-table-column prop="date" label="序号" width="110">
                      <template slot-scope="scope">
                        <!-- <el-input @keyup.native="limitInput($event)" v-model="scope.row.peopleCount"></el-input> -->
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="奖品类型">
                      <template slot-scope="scope">
                        <span
                          style="color: #2670fb; cursor: pointer"
                          v-if="
                            scope.row.prizeType == 3 ||
                            scope.row.prizeType == 10
                          "
                          @click="centerVis(scope)"
                          >{{ scope.row.title }}</span
                        >
                        <span
                          style="color: #2670fb; cursor: pointer"
                          v-else-if="scope.row.prizeType"
                          @click="centerVis(scope)"
                          >{{ scope.row.prizeType | prizeType }}</span
                        >
                        <span
                          v-else
                          @click="centerVis(scope)"
                          style="color: #2670fb; cursor: pointer"
                          >选择奖品</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          @blur="beAdd(scope.row)"
                          @input="
                            scope.row.prizeCount = getNumberData($event, 0)
                          "
                        ></el-input>
                        <div class="del_box">
                          <div class="delQx" @click="itemDel(scope.$index)">
                            <img src="@/assets/images/btn_del.svg" alt="" />
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div @click="addPrizeRule" class="add_btn1">
                    <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
                    添加奖项（{{ tableData.length }}/4）
                  </div>
                </div>
              </template>
              <template
                v-if="ruleForm.prizeRule == 1 && activityData.id !== 17"
              >
                <span>阶梯条件显示：</span>
                <el-radio-group
                  v-model="ladder.prizeShowType"
                  :disabled="isStartEdit"
                >
                  <el-radio :label="0"
                    >显示（C端小程序奖品上方会分别显示对应的阶梯条件）</el-radio
                  >
                  <el-radio :label="1">不显示</el-radio>
                </el-radio-group>
                <div>
                  <span>门槛统计：</span>
                  <el-select
                    v-model="ladder.orderCountType"
                    placeholder="请选择"
                    :disabled="isStartEdit"
                  >
                    <el-option
                      v-for="item in thresholdList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="prize_box">
                  <el-table
                    :header-cell-style="{
                      'text-align': 'center',
                      'border-bottom': '2px solid #EBEEF5',
                      background: '#FAFAFA',
                    }"
                    :cell-style="{
                      'text-align': 'center',
                      overflow: 'visible',
                    }"
                    :data="ladderData"
                    key="ladderData"
                    border
                    style="width: 800px; overflow: visible"
                  >
                    <el-table-column width="200" label="订单金额门槛">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.orderAmtLimit"
                          placeholder="请输入"
                          style="width: 100px"
                          :disabled="isStartEdit"
                          @input="
                            scope.row.orderAmtLimit = getNumberData2(
                              1,
                              $event,
                              1,
                              0
                            )
                          "
                        ></el-input>
                        元
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="商品件数门槛">
                      <template slot-scope="scope">
                        且满
                        <el-input
                          v-model="scope.row.itemTotalLimit"
                          placeholder="请输入"
                          style="width: 100px"
                          :disabled="isStartEdit"
                          @input="
                            scope.row.itemTotalLimit = getNumberData2(
                              1,
                              $event,
                              0,
                              1
                            )
                          "
                        ></el-input>
                        件
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="奖品类型">
                      <template slot-scope="scope">
                        <span
                          style="color: #7f85e9; cursor: pointer"
                          v-if="scope.row.prizeType == 3"
                          @click="centerVis2(scope)"
                          >{{ scope.row.title }}</span
                        >
                        <span
                          style="color: #7f85e9; cursor: pointer"
                          v-else-if="scope.row.prizeType"
                          @click="centerVis2(scope)"
                          >{{ scope.row.prizeType | prizeType }}</span
                        >
                        <span
                          v-else
                          @click="centerVis2(scope)"
                          style="color: #7b61ff; cursor: pointer"
                          >选择奖品</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          @blur="beAdd(scope.row)"
                          @input.native="
                            (e) =>
                              (scope.row.prizeCount = checkputn(
                                e,
                                scope.row,
                                'jindou'
                              ))
                          "
                          @input="
                            scope.row.prizeCount = getNumberData2(
                              1,
                              $event,
                              0,
                              1
                            )
                          "
                        ></el-input>
                        <!-- @blur="beAdd(scope.row)"
                        :disabled="activityData.isStart && !scope.row.minNum" -->
                        <div class="del_box">
                          <div
                            class="delQx"
                            @click="itemDelLadder(scope.$index)"
                          >
                            <img src="@/assets/images/btn_del.svg" alt="" />
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div
                    @click="addLadderRule"
                    class="add_btn1"
                    style="width: 125px"
                  >
                    <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
                    增加阶梯（{{ ladderData.length }}/4）
                  </div>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="曝光商品:" class="zindexBox">
              <el-checkbox
                v-model="ruleForm.exposureSwitch"
                @change="exposureSwitchChange"
              >
                是否添加曝光商品
              </el-checkbox>
              <el-button
                style="width: auto; margin: 0 15px"
                @click="exposureProducts"
                :disabled="ruleForm.exposureSwitch == false"
              >
                {{
                  itemListFor.length != ""
                    ? "添加曝光商品" + "(" + itemListFor.length + "/300" + ")"
                    : "添加曝光商品"
                }}
              </el-button>
              <!-- <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false">
                <el-radio :label="0">显示淘宝价</el-radio>
                <el-radio :label="1">显示促销价</el-radio>
              </el-radio-group> -->
              <draggable
                v-if="itemListFor.length > 0"
                v-model="mainImagelist"
                chosen-class="chosen"
                :scroll="true"
                animation="150"
                force-fallback="true"
                @start="isDragging = true"
                @end="onEnd"
                style="
                  margin-top: 10px;
                  background: rgba(38, 112, 251, 0.06);
                  padding: 10px 10px 0px 10px;
                "
              >
                <transition-group type="transition">
                  <div
                    v-for="(item, index) in mainImagelist"
                    :key="item.skuId + index"
                    style="display: inline-block; position: relative"
                    class="show_upImg2"
                  >
                    <img
                      :src="item.logo"
                      width="120px"
                      height="120px"
                      style="display: inline-block"
                    />&nbsp;
                    <!-- <div @click.stop="delec(index)" class="delectPosible">
                      <i class="el-icon-circle-close" style="font-size: 16px"></i>
                    </div> -->
                    <div class="delectPosible">
                      <span class="delectSort">拖动排序</span>
                      <img
                        src="@/assets/thdImg/pages/delet.svg"
                        @click.stop="delec(item, index)"
                        class="delectIcom"
                      />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <el-form-item label="活动规则:" required>
              <div
                style="
                  width: 500px;
                  backgroundcolor: rgba(250, 250, 250, 1);
                  padding: 8px;
                  position: relative;
                "
              >
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 484px"
                  resize="none"
                  v-model="ruleForm.activityRulesText"
                  :maxlength="2000"
                  :disabled="backgroundOpacity"
                ></el-input>
                <div class="prosi" style="color: #909399">
                  （{{
                    ruleForm.activityRulesText.length
                      ? ruleForm.activityRulesText.length
                      : 0
                  }}/2000）
                </div>
                <div>
                  <el-button
                    type="primary"
                    class="generate"
                    plain
                    @click="generateRule"
                    :disabled="backgroundOpacity"
                  >
                    生成规则
                  </el-button>

                  <span class="desc" style="margin-left: 8px">
                    <i
                      class="el-alert__icon el-icon-info"
                      style="color: #999"
                    ></i>
                    点击按钮自动生成规则，也可以自己编辑信息
                  </span>
                </div>
              </div>
            </el-form-item>
          </template>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>

    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="300"
    >
    </selectGoodsMonitor>
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      @transferName="selectGoodsCloseFilter"
      :postForm="selectGoodsFilterArr"
    >
    </selectGoodsMonitor>
    <!-- 排除购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter1"
      @transferName="selectGoodsCloseFilter1"
      :postForm="selectGoodsFilterArr1"
    >
    </selectGoodsMonitor>
    <!-- 双订单指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter5"
      @transferName="selectGoodsCloseFilter5"
      :postForm="selectGoodsFilterArr5"
    >
    </selectGoodsMonitor>
    <!-- 双订单排除购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter6"
      @transferName="selectGoodsCloseFilter6"
      :postForm="selectGoodsFilterArr6"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :JingdouCount="JingdouCount"
      :reShop="true"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- <img src="../../assets/images/new" /> -->
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import selectGoods from "@/components/select-goods2.vue";
import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  giftBagEide,
  editShopGift,
  getValidActivity,
  createPurchaseActivity,
  purchaseActivityDetail,
  editPurchaseActivity,
  publicOpen,
  prefixurl,
} from "@/api/paradiseAndTaskCommonController.js";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "淘宝E卡",
  "爱奇艺会员",
  "淘宝PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    selectGoods,
  },
  // props: {
  //   itemId: "",
  //   stepNum: {
  //     type: Number,
  //     default: 0,
  //   },
  //   activeValue: {
  //     type: Number,
  //   },
  //   valueRow: null,
  //   activityData: {
  //     type: Object,
  //   },
  //   isSave: {
  //     type: Boolean,
  //     default: true,
  //   },
  //   backgroundOpacity: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {},
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  data() {
    return {
      echoDateOne:{},
      echoDate:{},
      dataFromList: [
        {
          label: "付尾款或付款",
          value: "0",
        },
        {
          label: "收货",
          value: "1",
        },
      ],
      ruleOptions: [
        {
          label: "满足两个订单条件才可获奖",
          value: 1,
        },
        {
          label: "满足任意一个订单条件即可中奖",
          value: 2,
        },
      ],
      isStartEditTime: "",
      isStartEdit: false,
      valueRow: null,
      isCopy: false,
      localStep: 1,
      statusComment: false,
      localStepNum: 0,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      selectGoodsStateFilter1: false,
      selectGoodsStateFilter5: false,
      itemListForFilter1: [],
      selectGoodsFilterArr1: [],
      itemListForFilter5: [],
      selectGoodsFilterArr5: [],
      itemListForFilter6: [],
      selectGoodsFilterArr6: [],
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftID: "", // 礼包id
      giftList: [], // 礼包模板
      disableVF: true, // 人群禁用
      disableCUS: true, //  人群禁用
      dialogPrize: false, // 弹窗
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      // dialogPrize: true,
      levelList: [],
      disableTime: false,
      clickActual: false,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() >
                new Date(this.ruleForm.activityEndTime).getTime() ||
              time.getTime() < Date.now() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.orderEndTime).getTime()
            );
          } else {
          }
        },
      },
      //双订单下单时间限制
      pickerOrderEnd1: {
        disabledDate: (time) => {
          if (this.ruleExtraDTO.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleExtraDTO.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleExtraDTO.orderStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleExtraDTO.orderStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart1: {
        disabledDate: (time) => {
          if (this.ruleExtraDTO.orderEndTime) {
            return (
              time.getTime() >
              new Date(this.ruleExtraDTO.orderEndTime).getTime()
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,
      openExtraOrder: 0, //开启双订单条件， 1开启 0关闭
      extraOrderType: 1, //双订单规则类型， 1满足两个订单条件才可获奖 2满足任意一个订单条件即可中奖
      peopleList: [],
      ruleForm: {
        membershipTime:"",
        unlockTradeStatus: "1", //订单状态
        orderStatType: 0, //订单统计方式
        prizeRule: 0,
        //设置规则表单
        activityName: "",
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 复购 首购 下单
        condFollow: false, // 是否需要关注店铺
        days: "100", //近X天内未购
        orderStartTime: "", //下单开始时间
        orderEndTime: "", //下单结束时间
        orderStartTime1: "", //双订单下单开始时间
        orderEndTime1: "", //双订单下单结束时间
        orderStartCount: "", //订单开始笔数
        orderEndCount: "", //订单结束笔数
        orderStartPayment: "", //订单开始金额
        orderEndPayment: "", //订单结束金额
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是

        isMemberGiftCheck: false,
        isHavePrizes: "2",
        prizes: [], // 礼包样式  积分  京豆等等
        itemList: [], //曝光商品集合
        joinDay:''
      },
      selectGoodsStateFilter6: false,
      ruleExtraDTO: {
        orderStartTime: "",
        orderEndTime: "",
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: [],
        orderStartCount: "",
        orderEndCount: "",
        orderStartPayment: "",
        orderEndPayment: "",
      },
      ladder: {
        prizeShowType: 0,
        orderCountType: 0,
      },
      thresholdList: [
        {
          value: 0,
          label: "单笔满",
        },
        {
          value: 1,
          label: "累计满",
        },
      ],
      ladderData: [
        {
          orderAmtLimit: "", //订单门槛orderAmtLimit
          itemTotalLimit: "", //商品件数门槛itemTotalLimit
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
        {
          orderAmtLimit: "", //订单门槛
          itemTotalLimit: "", //商品件数门槛
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      ladderIndex: null,
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      orderCRM: false,
      orderCRMtime: "",
      activityUrl: "",
      venderId: "",
    };
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log("this.$route.query------>", this.$route.query);
    console.log("this.localStepNum------>", this.localStepNum);
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
        this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.getEdit();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.isStartEdit = false;
      this.getEdit();
    } else {
      this.activityTimeChange();
    }
    console.log("this.activeValue444------>", this.activeValue);
  },
  mounted() {
    this.getLevel();
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    // 数据初始化
    async getPolite() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "0",
          openMerchant: "",
          openType: 0,
          templateUrl: "",
          updateTime: "2021-11-12 10:19:55",
        },
      ];
      if (this.activityData.id == 16) {
        this.giftList[0].templateUrl = require("../../assets/images/integralCenter/xdyl.png");
      } else if (this.activityData.id == 17) {
        this.giftList[0].templateUrl = require("../../assets/images/integralCenter/sgyl.png");
      } else {
        this.giftList[0].templateUrl = require("../../assets/images/integralCenter/fgyl.png");
      }
      const { message: res } = await publicOpen();
      if (res) {
        this.orderCRMtime = res;
        this.orderCRM = false;
      } else {
        if (this.venderType) {
          this.orderCRM = true;
        } else {
          this.orderCRM = false;
        }
        this.orderCRMtime = "";
      }
      const data = await prefixurl();
      this.activityUrl = data.data.activityUrl;
      this.venderId = data.data.venderId;
    },
    // 修改 数据回显
    getEdit() {
      //关注店铺有礼
      purchaseActivityDetail(this.valueRow.id).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? Number(res.data.newOldCustomer)
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.activityRulesText = this.isCopy
          ? ""
          : String(res.data.ruleDescription); //生成规则

        if (this.isStartEdit) {
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime);
        }

        // 奖品
        this.ruleForm.condFollow =
          res.data.ruleDto.condFollow == 1 ? true : false;
        if (this.activityData.id != 16) {
          this.ruleForm.days = res.data.ruleDto.days;
        }

        this.ruleForm.orderStartTime = res.data.ruleDto.orderStartTime;
        this.ruleForm.orderEndTime = res.data.ruleDto.orderEndTime;
        this.ruleForm.orderStartCount = this.isCopy
          ? ""
          : res.data.ruleDto.orderStartCount;
        this.ruleForm.orderEndCount = this.isCopy
          ? ""
          : res.data.ruleDto.orderEndCount;
        this.ruleForm.orderStartPayment = this.isCopy
          ? ""
          : res.data.ruleDto.orderStartPayment;
        this.ruleForm.orderEndPayment = this.isCopy
          ? ""
          : res.data.ruleDto.orderEndPayment;
        this.ruleForm.filterType = String(res.data.ruleDto.filterType);
        this.openExtraOrder = res.data.openExtraOrder;
        this.extraOrderType =
          res.data.extraOrderType == 0 ? 1 : res.data.extraOrderType;
          
        this.ruleForm.joinDay = res.data.ruleDto.joinDay
        //双订单
        if (res.data.ruleExtraDTO) {
          this.ruleExtraDTO.orderStartTime =
            this.openExtraOrder == 1
              ? res.data.ruleExtraDTO.orderStartTime
              : "";
          this.ruleExtraDTO.orderEndTime =
            this.openExtraOrder == 1 ? res.data.ruleExtraDTO.orderEndTime : "";
          this.ruleExtraDTO.filterType = String(
            res.data.ruleExtraDTO.filterType
          );
          this.ruleExtraDTO.orderStartCount = this.isCopy
            ? ""
            : res.data.ruleExtraDTO.orderStartCount;
          this.ruleExtraDTO.orderEndCount = this.isCopy
            ? ""
            : res.data.ruleExtraDTO.orderEndCount;
          this.ruleExtraDTO.orderStartPayment = this.isCopy
            ? ""
            : res.data.ruleExtraDTO.orderStartPayment;
          this.ruleExtraDTO.orderEndPayment = this.isCopy
            ? ""
            : res.data.ruleExtraDTO.orderEndPayment;
        }

        this.ruleForm.radio = res.data.priceType; // 0：显示淘宝价 1：显示促销价 ,
        this.ruleForm.orderStatType = res.data.ruleDto.orderStatType //订单统计方式回显
        this.ruleForm.unlockTradeStatus = String(res.data.ruleDto.unlockTradeStatus) //订单状态

        // 指定购买商品
        if (res.data.ruleDto.filterType == 1) {
          this.itemListForFilter = res.data.ruleDto.itemList.map((item) => {
            return {
              ...item,
              numIid: item.wareId,
              itemTitle: item.title,
              picUrl: item.logo,
            };
          });
          this.selectGoodsFilterArr = this.itemListForFilter;
        }

        // 排除商品
        if (res.data.ruleDto.filterType == 2) {
          this.itemListForFilter1 = res.data.ruleDto.itemList.map((item) => {
            return {
              ...item,
              numIid: item.wareId,
              itemTitle: item.title,
              picUrl: item.logo,
            };
          });
          this.selectGoodsFilterArr1 = this.itemListForFilter1;
        }

        // 双订单指定购买商品
        if (res.data.ruleExtraDTO && res.data.ruleExtraDTO.filterType == 1) {
          this.itemListForFilter5 = res.data.ruleExtraDTO.skuIdList.map(
            (item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            }
          );
          this.selectGoodsFilterArr5 = this.itemListForFilter5;
        }

        // 双订单排除商品
        if (res.data.ruleExtraDTO && res.data.ruleExtraDTO.filterType == 2) {
          this.itemListForFilter6 = res.data.ruleExtraDTO.skuIdList.map(
            (item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            }
          );
          this.selectGoodsFilterArr6 = this.itemListForFilter6;
        }

        if (res.data.ruleDto.prizeRule == 1 && !this.isCopy) {
          this.ladder.prizeShowType = res.data.ruleDto.prizeShowType;
          this.ladder.orderCountType = res.data.ruleDto.orderCountType;
        }

        //奖品设置
        // this.ruleForm.prizeRule = this.isCopy ? 0 : (res.data.ruleDto.prizeRule || 0);
        this.ruleForm.prizeRule = res.data.ruleDto.prizeRule
          ? res.data.ruleDto.prizeRule
          : 0;

        if (res.data.ruleDto.prizeRule == 1) {
          if (!this.isCopy) {
            this.ladderData = res.data.pointActivityPrizeDTOList.map(
              (item, index) => {
                let obj = {
                  id: item.id,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  logo: item.logo,
                  discount: item.price || item.singleAmount,
                  singleAmount: item.singleAmount,
                  price: item.price,
                  prizeCount: item.totalAmount,
                  minNum: item.totalAmount,
                  orderAmtLimit: item.orderAmtLimit,
                  itemTotalLimit: item.itemTotalLimit,
                };
                if (item.prizeType == 1) {
                  obj.quota = item.quota;
                  obj.couponType = item.couponType;
                }
                //开启自定义信息
                if (item.prizeRemarkType == 1) {
                  obj.prizeRemarkType = item.prizeRemarkType;
                  obj.receivePayment =
                    item.pointActivityPrizeRemark.receivePayment;
                  obj.tradeLimitTime =
                    item.pointActivityPrizeRemark.tradeLimitTime;
                  obj.tradeLimitTimeUnit =
                    item.pointActivityPrizeRemark.tradeLimitTimeUnit;
                  obj.itemType = item.pointActivityPrizeRemark.itemType;
                  obj.tradeFlag = item.pointActivityPrizeRemark.tradeFlag;
                  obj.content = item.pointActivityPrizeRemark.content;
                  obj.numIid = item.pointActivityPrizeRemark.numIid;
                  obj.remarkActionType = item.pointActivityPrizeRemark.remarkActionType;
                  obj.startCreateTradeTimeForManualLinkTrade = item.pointActivityPrizeRemark.startCreateTradeTimeForManualLinkTrade;
                  obj.endCreateTradeTimeForManualLinkTrade  = item.pointActivityPrizeRemark.endCreateTradeTimeForManualLinkTrade;
                }
                return obj;
              }
            );
          } else {
            this.ladderData = [
              {
                orderAmtLimit: "", //订单门槛orderAmtLimit
                itemTotalLimit: "", //商品件数门槛itemTotalLimit
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              },
              {
                orderAmtLimit: "", //订单门槛
                itemTotalLimit: "", //商品件数门槛
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              },
            ];
          }
        } else {
          if (!this.isCopy) {
            this.tableData = res.data.pointActivityPrizeDTOList.map(
              (item, index) => {
                let obj = {
                  id: item.id,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  logo: item.logo,
                  discount: item.price || item.singleAmount,
                  singleAmount: item.singleAmount,
                  price: item.price,
                  prizeCount: item.totalAmount,
                  minNum: item.totalAmount,
                };
                if (item.prizeType == 1) {
                  obj.quota = item.quota;
                  obj.couponType = item.couponType;
                  if (item.couponType == 4) {
                    obj.batchKey = item.batchKey;
                    obj.assetsId = null;
                  }
                }
                //开启自定义信息
                if (item.prizeRemarkType == 1) {
                  obj.prizeRemarkType = item.prizeRemarkType;
                  obj.receivePayment =
                    item.pointActivityPrizeRemark.receivePayment;
                  obj.tradeLimitTime =
                    item.pointActivityPrizeRemark.tradeLimitTime;
                  obj.tradeLimitTimeUnit =
                    item.pointActivityPrizeRemark.tradeLimitTimeUnit;
                  obj.itemType = item.pointActivityPrizeRemark.itemType;
                  obj.tradeFlag = item.pointActivityPrizeRemark.tradeFlag;
                  obj.content = item.pointActivityPrizeRemark.content;
                  obj.numIid = item.pointActivityPrizeRemark.numIid;
                  obj.remarkActionType = item.pointActivityPrizeRemark.remarkActionType;
                  obj.startCreateTradeTimeForManualLinkTrade = item.pointActivityPrizeRemark.startCreateTradeTimeForManualLinkTrade;
                  obj.endCreateTradeTimeForManualLinkTrade  = item.pointActivityPrizeRemark.endCreateTradeTimeForManualLinkTrade;
                }
                //备注开启
                return obj;
              }
            );
          } else {
            this.tableData = [
              {
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              },
            ];
          }
        }

        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        // 商品处理
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.mainImagelist = shopList;
        this.itemListFor = shopList;
        this.activityTimeChange();
      });
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },

    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    itemDel(index) {
      if (this.isStartEdit) return;
      if (this.tableData.length == 1) {
        this.$message.warning("必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
    },
    addPrizeRule() {
      if (this.isStartEdit) return;
      if (this.tableData.length === 4) {
        this.$message.warning("最多可设置4个奖项");
        return;
      }
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    // 阶梯奖品
    addLadderRule() {
      if (this.isStartEdit) return;
      if (this.ladderData.length === 4) {
        this.$message.warning("最多可设置4个阶梯");
        return;
      }
      this.ladderData.push({});
    },
    itemDelLadder(index) {
      if (this.isStartEdit) return;
      if (this.ladderData.length == 2) {
        this.$message.warning("必须有两个个阶梯");
        return;
      }
      this.ladderData.splice(index, 1);
    },

    //选择商品数据 曝光
    getTheData(data, prizeType) {
      this.showDialog = false;
      if (this.ruleForm.prizeRule == "1") {
        this.ladderData[this.ladderIndex].prizeType = prizeType;
        this.ladderData[this.ladderIndex].price =
          data.discount || data.singleAmount;
        this.ladderData[this.ladderIndex].singleAmount = data.singleAmount;
        this.ladderData[this.ladderIndex].title = data.name || prizeType;
        this.ladderData[this.ladderIndex].assetsId = Number(data.couponId);
        this.ladderData[this.ladderIndex].logo = data.logo;
        if (prizeType == 1) {
          this.ladderData[this.ladderIndex].quota = data.quota;
          this.ladderData[this.ladderIndex].couponType = data.couponType;
          if (data.couponType == 4) {
            this.ladderData[this.ladderIndex].prizeType = prizeType;
            this.ladderData[this.ladderIndex].price = data.price;
            this.ladderData[this.ladderIndex].singleAmount = data.singleAmount;
            this.ladderData[this.ladderIndex].price = data.price;
            this.ladderData[this.ladderIndex].assetsId = null;
            this.ladderData[this.ladderIndex].batchKey = data.batchKey;
          }
        }
        if (prizeType == 2) {
          this.ladderData[this.ladderIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 10) {
          this.ladderData[this.ladderIndex].price = data.price;
          this.ladderData[this.ladderIndex].assetsId = data.id;
          this.ladderData[this.ladderIndex].logo = data.picUrl;
          this.ladderData[this.ladderIndex].title = data.itemTitle;
        }
      } else {
        this.tableData[this.tableIndex].prizeType = prizeType;
        this.tableData[this.tableIndex].price =
          data.discount || data.singleAmount;
        this.tableData[this.tableIndex].singleAmount = data.singleAmount;
        this.tableData[this.tableIndex].title = data.name || prizeType;
        this.tableData[this.tableIndex].assetsId = Number(data.couponId);
        this.tableData[this.tableIndex].logo = data.logo;
        if (prizeType == 1) {
          this.tableData[this.tableIndex].quota = data.quota;
          this.tableData[this.tableIndex].couponType = data.couponType;
          if (data.couponType == 4) {
            this.tableData[this.tableIndex].prizeType = prizeType;
            this.tableData[this.tableIndex].price = data.price;
            this.tableData[this.tableIndex].singleAmount = data.singleAmount;
            this.tableData[this.tableIndex].price = data.price;
            this.tableData[this.tableIndex].assetsId = null;
            this.tableData[this.tableIndex].batchKey = data.batchKey;
          }
        }
        if (prizeType == 2) {
          this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 10) {
          this.tableData[this.tableIndex].price = data.price;
          this.tableData[this.tableIndex].assetsId = data.id;
          this.tableData[this.tableIndex].logo = data.picUrl;
          this.tableData[this.tableIndex].title = data.itemTitle;
        }
      }
      //订单备注开启
      console.log(data,'===========');
      
      if (data.prizeRemarkType == 1 && this.ruleForm.prizeRule != "1") {
        this.tableData[this.tableIndex].prizeRemarkType = data.prizeRemarkType;
        this.tableData[this.tableIndex].receivePayment = data.receivePayment;
        this.tableData[this.tableIndex].itemType = data.itemType;
        this.tableData[this.tableIndex].tradeFlag = data.tradeFlag;
        this.tableData[this.tableIndex].content = data.content;
        this.tableData[this.tableIndex].remarkActionType = data.remarkActionType;
        if(data.remarkActionType == '1'){
          this.tableData[this.tableIndex].startCreateTradeTimeForManualLinkTrade = data.startCreateTradeTimeForManualLinkTrade;
          this.tableData[this.tableIndex].endCreateTradeTimeForManualLinkTrade = data.endCreateTradeTimeForManualLinkTrade;
        }else{
          this.tableData[this.tableIndex].tradeLimitTime = data.tradeLimitTime;
          this.tableData[this.tableIndex].tradeLimitTimeUnit = data.tradeLimitTimeUnit;
        }
        if (data.itemType) {
          const arr = data.goodsList.map((item) => item.wareId);
          this.tableData[this.tableIndex].numIid = arr.join(",");
        } else {
          this.tableData[this.tableIndex].numIid = "";
        }
      }else if(data.prizeRemarkType == 1 && this.ruleForm.prizeRule == "1"){
        //阶梯奖品
        this.ladderData[this.ladderIndex].prizeRemarkType = data.prizeRemarkType;
        this.ladderData[this.ladderIndex].receivePayment = data.receivePayment;
        this.ladderData[this.ladderIndex].tradeLimitTime = data.tradeLimitTime;
        this.ladderData[this.ladderIndex].tradeLimitTimeUnit =
          data.tradeLimitTimeUnit;
        this.ladderData[this.ladderIndex].itemType = data.itemType;
        this.ladderData[this.ladderIndex].tradeFlag = data.tradeFlag;
        this.ladderData[this.ladderIndex].content = data.content;
        this.ladderData[this.ladderIndex].remarkActionType = data.remarkActionType;
        if(data.remarkActionType == '1'){
          this.ladderData[this.ladderIndex].startCreateTradeTimeForManualLinkTrade = data.startCreateTradeTimeForManualLinkTrade;
          this.ladderData[this.ladderIndex].endCreateTradeTimeForManualLinkTrade = data.endCreateTradeTimeForManualLinkTrade;
        }else{
          this.ladderData[this.ladderIndex].tradeLimitTime = data.tradeLimitTime;
          this.ladderData[this.ladderIndex].tradeLimitTimeUnit = data.tradeLimitTimeUnit;
        }
        if (data.itemType) {
          const arr = data.goodsList.map((item) => item.wareId);
          this.ladderData[this.ladderIndex].numIid = arr.join(",");
        } else {
          this.ladderData[this.ladderIndex].numIid = "";
        }
      }
    },

    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    clearDoubleOrderTime() {
      this.ruleExtraDTO.orderStartTime = null;
      this.ruleExtraDTO.orderEndTime = null;
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }
      console.log(this.mainImagelist, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if (this.isStartEdit) return;
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (
        this.tableData[scope.$index].prizeType == 3 ||
        this.tableData[scope.$index].prizeType == 10
      ) {
        this.clickActual = true;
      }
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(scope.row)
      });
    },
    centerVis2(scope) {
      if (this.isStartEdit) return;
      this.ladderIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (
        this.ladderData[scope.$index].prizeType == 3 ||
        this.ladderData[scope.$index].prizeType == 10
      ) {
        this.clickActual = true;
      }
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(scope.row)
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // if (days > 90) {
        //   this.$message.warning("活动时间不得超过90天！");
        //   this.ruleForm.activityEndTime = null;
        //   this.timeOut = 0;
        //   this.timeDay = 0;
        //   return;
        // }

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        } else if (!this.isStartEdit) {
          console.log(this.activityTimeValue);

          this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          this.activityTimeValue[0] = "";
          this.ruleForm.activityStartTime = null;
          return;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
      // if (
      //   this.ruleForm.activityEndTime &&
      //   this.ruleForm.activityStartTime &&
      //   this.ruleForm.activityEndTime.substring(0, 10) == this.ruleForm.activityStartTime.substring(0, 10)
      // ) {
      //   this.$message.warning("活动时间不能小于一天");
      //   this.ruleForm.activityEndTime = "";
      // }
    },
    // 下单时间
    orderChange() {
      let start = new Date(this.ruleForm.orderStartTime).valueOf();
      let end = new Date(this.ruleForm.orderEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.orderStartTime &&
        this.ruleForm.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.orderEndTime &&
        this.ruleForm.orderEndTime.substring(0, 10);
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("下单时间最大范围为近1年");
          this.ruleForm.orderEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 双下单时间
    orderDoubleChange() {
      let start = new Date(this.ruleExtraDTO.orderStartTime).valueOf();
      let end = new Date(this.ruleExtraDTO.orderEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleExtraDTO.orderStartTime &&
        this.ruleExtraDTO.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleExtraDTO.orderEndTime &&
        this.ruleExtraDTO.orderEndTime.substring(0, 10);
      if (this.ruleExtraDTO.orderStartTime && this.ruleExtraDTO.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("下单时间最大范围为近1年");
          this.ruleExtraDTO.orderEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 规则判断
    changDays() {
      if (Number(this.ruleForm.days) > 730) {
        this.$message.warning("范围为1-90天!");
        this.ruleForm.days = "";
      }
      if (
        this.ruleForm.orderStartCount &&
        this.ruleForm.orderEndCount &&
        Number(this.ruleForm.orderStartCount) >=
          Number(this.ruleForm.orderEndCount)
      ) {
        this.$message.warning("商品结束件数要大于商品开始件数!");
        this.ruleForm.orderEndCount = "";
      }
      if (
        this.ruleForm.orderStartPayment &&
        this.ruleForm.orderEndPayment &&
        Number(this.ruleForm.orderStartPayment) >=
          Number(this.ruleForm.orderEndPayment)
      ) {
        this.$message.warning("订单结束金额要大于订单开始金额!");
        this.ruleForm.orderEndPayment = "";
      }
    },
    //双订单
    changDays2() {
      if (Number(this.ruleForm.days) > 730) {
        this.$message.warning("范围为1-90天!");
        this.ruleForm.days = "";
      }
      if (
        this.ruleExtraDTO.orderStartCount &&
        this.ruleExtraDTO.orderEndCount &&
        Number(this.ruleExtraDTO.orderStartCount) >=
          Number(this.ruleExtraDTO.orderEndCount)
      ) {
        this.$message.warning("商品结束件数要大于商品开始件数!");
        this.ruleExtraDTO.orderEndCount = "";
      }
      if (
        this.ruleExtraDTO.orderStartPayment &&
        this.ruleExtraDTO.orderEndPayment &&
        Number(this.ruleExtraDTO.orderStartPayment) >=
          Number(this.ruleExtraDTO.orderEndPayment)
      ) {
        this.$message.warning("订单结束金额要大于订单开始金额!");
        this.ruleExtraDTO.orderEndPayment = "";
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      this.joinBlackList = true;
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      console.log(
        145454,
        this.ruleForm.orderStatType,
        this.ruleForm.unlockTradeStatus
      );

      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示淘宝价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        openExtraOrder: this.openExtraOrder, //开启双订单条件， 1开启 0关闭
        extraOrderType: this.extraOrderType, //双订单规则类型， 1满足两个订单条件才可获奖 2满足任意一个订单条件即可中奖
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        ruleDTO: {
          subType: this.activityData.id, //活动类型  16: 下单有礼 17: 首购有礼 18:复购有礼
          condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
          days: this.ruleForm.days, //近X天内未购
          orderStartTime: this.ruleForm.orderStartTime,
          orderEndTime: this.ruleForm.orderEndTime,
          orderStartCount: this.ruleForm.orderStartCount,
          orderEndCount: this.ruleForm.orderEndCount,
          orderStartPayment: this.ruleForm.orderStartPayment,
          orderEndPayment: this.ruleForm.orderEndPayment,
          orderStatType: this.ruleForm.orderStatType,
          unlockTradeStatus: this.ruleForm.unlockTradeStatus,
          prizeRule: this.ruleForm.prizeRule,
          prizeShowType: this.ladder.prizeShowType,
          orderCountType: this.ladder.orderCountType,
          joinDay: this.ruleForm.joinDay,

          filterType: this.ruleForm.filterType,
          skuIdList:
            this.ruleForm.filterType == 2
              ? this.itemListForFilter1.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                })
              : this.itemListForFilter.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                }),
        }, //活动名称
        ruleExtraDTO: {
          subType: this.activityData.id, //活动类型  16: 下单有礼 17: 首购有礼 18:复购有礼
          days: this.ruleForm.days, //近X天内未购
          condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺

          orderStartTime: this.ruleExtraDTO.orderStartTime,
          orderEndTime: this.ruleExtraDTO.orderEndTime,
          filterType: this.ruleExtraDTO.filterType,
          orderStartCount: this.ruleExtraDTO.orderStartCount,
          orderEndCount: this.ruleExtraDTO.orderEndCount,
          orderStartPayment: this.ruleExtraDTO.orderStartPayment,
          orderEndPayment: this.ruleExtraDTO.orderEndPayment,

          skuIdList:
            this.ruleExtraDTO.filterType == 2
              ? this.itemListForFilter6.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                })
              : this.itemListForFilter5.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                }),
        },
        pointActivityPrizeDTOList: [], // 奖品
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        points: 10,
      };
      if (this.ruleForm.prizeRule == "1") {
        console.log(this.ladderData, "6545465465");
        cardParams.pointActivityPrizeDTOList = this.ladderData.map((item) => {
          let prize = {
            id: item.id,
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.prizeCount, // 总数额
            price: item.price,
            orderAmtLimit: item.orderAmtLimit,
            itemTotalLimit: item.itemTotalLimit,
            prizeRemarkType: item.prizeRemarkType,
            pointActivityPrizeRemark: {
              remarkActionType:item.remarkActionType,
              receivePayment: item.receivePayment,
              tradeLimitTime: item.tradeLimitTime,
              tradeLimitTimeUnit: item.tradeLimitTimeUnit,
              itemType: item.itemType,
              tradeFlag: item.tradeFlag,
              content: item.content,
              numIid: item.numIid,
              startCreateTradeTimeForManualLinkTrade:item.startCreateTradeTimeForManualLinkTrade,
              endCreateTradeTimeForManualLinkTrade:item.endCreateTradeTimeForManualLinkTrade,
            },
          };
          if (prize.prizeType == 3 || prize.prizeType == 10) {
            prize.logo = item.logo;
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
            if (item.couponType == 4) {
              prize.batchKey = item.batchKey;
            }
          }
          // if (prize.prizeType != 2 && prize.prizeType != 4) {
          // if (prize.prizeType != 1 && prize.prizeType != 3) {
          //   console.log(item.discount);
          //   prize.price = item.price;
          // }
          return prize;
        });
      } else {
        cardParams.pointActivityPrizeDTOList = this.tableData.map((item) => {
          let prize = {
            id: item.id,
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.prizeCount, // 总数额
            price: item.price,
            prizeRemarkType: item.prizeRemarkType,
            pointActivityPrizeRemark: {
              remarkActionType:item.remarkActionType,
              receivePayment: item.receivePayment,
              tradeLimitTime: item.tradeLimitTime,
              tradeLimitTimeUnit: item.tradeLimitTimeUnit,
              itemType: item.itemType,
              tradeFlag: item.tradeFlag,
              content: item.content,
              numIid: item.numIid,
              startCreateTradeTimeForManualLinkTrade:item.startCreateTradeTimeForManualLinkTrade,
              endCreateTradeTimeForManualLinkTrade:item.endCreateTradeTimeForManualLinkTrade,
            },
          };
          if (prize.prizeType == 3 || prize.prizeType == 10) {
            prize.logo = item.logo;
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
            if (item.couponType == 4) {
              prize.batchKey = item.batchKey;
            }
          }
          // if (prize.prizeType != 2 && prize.prizeType != 4) {
          // if (prize.prizeType != 1 && prize.prizeType != 3) {
          //   console.log(item.discount);
          //   prize.price = item.price;
          // }
          return prize;
        });
      }
      // console.log(this.tableData);
      // console.log(cardParams);
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
                wareId: obj.numIid,
              });
            }
          });
        }
        cardParams.itemList = b;
      }
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //复购规则不能为空
      if (this.activityData.id != 16) {
        if (!this.ruleForm.days) {
          this.$message.warning(
            `${this.activityData.id == 17 ? "首购" : "复购"}规则不能为空`
          );
          return;
        }
      }
      //下单时间不能为空
      if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
        this.$message.warning("请填写下单时间！");
        return;
      }

      if (this.ruleForm.prizeRule == "1") {
        //奖品设置最少一项
        if (this.ladderData.length === 0) {
          this.$message.warning("奖品设置最少两项！");
          return;
        }

        // 请将奖品填写完整！
        let isFlay = false;
        this.ladderData.forEach((item) => {
          if (!item.price || !item.prizeCount) {
            isFlay = true;
          }
        });
        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }

        let isFlay2 = false;
        this.ladderData.forEach((item) => {
          if (!item.orderAmtLimit || !item.itemTotalLimit) {
            isFlay2 = true;
          }
        });
        if (isFlay2) {
          return this.$message.warning(
            "请填写订单金额门槛和请填写商品件数门槛！"
          );
        }

        let isOk = false;
        for (let i = 0; i < this.ladderData.length; i++) {
          // console.log("i",i)
          // console.log("this.ladderData",this.ladderData)
          // console.log("this.ladderData[i]",this.ladderData[i])
          // console.log("this.ladderData[i-1]",this.ladderData[i-1])
          // if(this.ladderData[i].orderAmtLimit <= this.ladderData[i-1].orderAmtLimit &&
          //   this.ladderData[i].itemTotalLimit <= this.ladderData[i-1].itemTotalLimit){
          //     isOk = true;
          // }
          for (let j = i + 1; j < this.ladderData.length; j++) {
            if (
              Number(this.ladderData[i].orderAmtLimit) >=
                Number(this.ladderData[j].orderAmtLimit) &&
              Number(this.ladderData[i].itemTotalLimit) >=
                Number(this.ladderData[j].itemTotalLimit)
            ) {
              console.log("i", i, this.ladderData.length, j);
              console.log(
                "this.ladderData[i]",
                this.ladderData[i].orderAmtLimit,
                this.ladderData[i].itemTotalLimit
              );
              console.log(
                "this.ladderData[j]",
                this.ladderData[j].orderAmtLimit,
                this.ladderData[j].itemTotalLimit
              );
              console.log(
                "1100",
                Number(this.ladderData[i].orderAmtLimit) >=
                  Number(this.ladderData[j].orderAmtLimit),
                Number(this.ladderData[i].itemTotalLimit) >=
                  Number(this.ladderData[j].itemTotalLimit)
              );
              isOk = true;
            }
          }
        }
        if (isOk) {
          return this.$message.warning(
            "阶梯条件设置有误，下一个阶梯的订单金额和商品件数不能同时小于等于上一阶梯的值哦~"
          );
        }
      } else {
        //商品件数不能为空
        if (!this.ruleForm.orderStartCount) {
          this.$message.warning("请填写商品件数");
          return;
        }
        //订单金额不能为空
        if (!this.ruleForm.orderStartPayment) {
          this.$message.warning("请填写订单金额");
          return;
        }
        //双订单
        if (this.openExtraOrder == 1) {
          //下单时间不能为空
          if (
            !this.ruleExtraDTO.orderStartTime ||
            !this.ruleExtraDTO.orderEndTime
          ) {
            this.$message.warning("请填写下单时间！");
            return;
          }
          //商品件数不能为空
          if (!this.ruleExtraDTO.orderStartCount) {
            this.$message.warning("请填写商品件数");
            return;
          }
          //订单金额不能为空
          if (!this.ruleExtraDTO.orderStartPayment) {
            this.$message.warning("请填写订单金额");
            return;
          }
        }
        //奖品设置最少一项
        if (this.tableData.length === 0) {
          this.$message.warning("奖品设置最少一项！");
          return;
        }
        if (this.ruleForm.filterType == 1) {
          if (this.itemListForFilter.length == 0) {
            this.$message.warning("请添加指定商品！");
            return;
          }
        }

        if (this.ruleForm.filterType == 2) {
          if (this.itemListForFilter1.length == 0) {
            this.$message.warning("请添加排除商品！");
            return;
          }
        }

        //双订单
        if (this.openExtraOrder == 1) {
          if (this.ruleExtraDTO.filterType == 1) {
            if (this.itemListForFilter5.length == 0) {
              this.$message.warning("请添加指定商品！");
              return;
            }
          }
          if (this.ruleExtraDTO.filterType == 2) {
            if (this.itemListForFilter6.length == 0) {
              this.$message.warning("请添加排除商品！");
              return;
            }
          }
        }
        // 请将奖品填写完整！
        let isFlay = false;
        this.tableData.forEach((item) => {
          if (!item.price || !item.prizeCount) {
            isFlay = true;
          }
        });
        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }
      }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListFor.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      //活动规则不能为空
      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.valueRow && !this.isCopy) {
          editPurchaseActivity({
            ...cardParams,
            pointActivityId: this.valueRow.id,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          cardParams.templateId = this.activityData.templateId;
          createPurchaseActivity(cardParams).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        test1 = "",
        test2 = "",
        test3 = "";

      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 =
          "活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime +
          "（奖品发完，活动将会提前结束）";
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });
        text3 = "活动参与对象：" + levelText.splice(",");
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }

      //活动条件
      if (this.ruleForm.condFollow) {
        text4 = "活动条件：" + "已关注店铺，可参与活动";
      }
      //首购规则：
      if (this.activityData.id != 16) {
        if (this.ruleForm.days) {
          text5 = `${
            this.activityData.id == 17 ? "首购" : "复购"
          }规则：活动下单开始时间前的${this.ruleForm.days}天内${
            this.activityData.id == 17 ? "未购" : "已购会员可参与"
          }`;
        }
      }
      // 下单时间
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        test1 =
          "参与规则：下单时间：" +
          this.ruleForm.orderStartTime +
          "~" +
          this.ruleForm.orderEndTime +
          ";";
      }
      // 订单笔数： 统一奖品才有
      if (this.ruleForm.orderStartCount && this.ruleForm.prizeRule == 0) {
        if (this.ruleForm.orderEndCount) {
          test2 =
            "商品件数：" +
            this.ruleForm.orderStartCount +
            "件~" +
            this.ruleForm.orderEndCount +
            "件" +
            ";";
        } else {
          test2 = "商品件数：" + this.ruleForm.orderStartCount + "件及以上;";
        }
      }
      // 订单金额：统一奖品才有
      if (this.ruleForm.orderStartPayment && this.ruleForm.prizeRule == 0) {
        if (this.ruleForm.orderEndPayment) {
          test3 =
            "订单金额：" +
            this.ruleForm.orderStartPayment +
            "元~" +
            this.ruleForm.orderEndPayment +
            "元";
        } else {
          test3 = "订单金额：" + this.ruleForm.orderStartPayment + "元及以上";
        }
      }
      text6 = test1 + test2 + test3;
      //奖品设置
      this.tableData.forEach((item, index) => {
        let result = "";
        if (item.prizeType == "1") {
          result = item.price + "元优惠券";
        } else if (item.prizeType == "2") {
          result = item.price + "京豆";
        } else if (item.prizeType == "3") {
          result = item.price + "元#" + item.title;
        } else if (item.prizeType == "4") {
          result = item.price + "店铺积分";
        } else if (item.prizeType == "5") {
          result = item.price + "元淘宝E卡";
        } else if (item.prizeType == "6") {
          result = item.price + "元爱奇艺会员";
        } else if (item.prizeType == "7") {
          result = item.price + "元淘宝PLUS会员";
        } else if (item.prizeType == "8") {
          result = item.price + "元现金红包";
        }
        if (item.price && item.prizeCount) {
          text9 += `${index + 1}) ${result}`;
        }
      });
      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push(v.informationmationOne);
      });
      levetListTwo = levetListOne.join(",");
      levetListThree = levetList.join(",");
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }
      let text10 = "在活动结束后不可领取奖励";
      let Arr1 = [text1, text2, text3,text34, text4, text5, text6, text9, text10];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    filterTypeChange(val) {
      if (val == "0") {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.itemListForFilter1 = [];
        this.selectGoodsFilterArr1 = [];
      }
    },
    filterTypeChange1(val) {
      if (val == "0") {
        this.itemListForFilter5 = [];
        this.selectGoodsFilterArr5 = [];
        this.itemListForFilter6 = [];
        this.selectGoodsFilterArr6 = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        // this.mainImagelist = [];
      }
      // this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //排除购买商品商品弹窗
    exposureProductsFiter1() {
      this.selectGoodsStateFilter1 = true;
      if (this.itemListForFilter1.length == 0) {
        this.itemListForFilter1 = [];
        this.selectGoodsFilterArr1 = [];
      }
      // this.$refs.selectGoFilter2.handleRightCurrentChange(1);
    },
    //双订单指定购买商品商品弹窗
    exposureProductsFiter5() {
      this.selectGoodsStateFilter5 = true;
      if (this.itemListForFilter5.length == 0) {
        this.itemListForFilter5 = [];
        this.selectGoodsFilterArr5 = [];
      }
      // this.$refs.selectGoFilter2.handleRightCurrentChange(1);
    },
    //双订单排除购买商品商品弹窗
    exposureProductsFiter6() {
      this.selectGoodsStateFilter6 = true;
      if (this.itemListForFilter6.length == 0) {
        this.itemListForFilter6 = [];
        this.selectGoodsFilterArr6 = [];
      }
      // this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      // if (data) {
      //   console.log(data);
      //   this.itemListFor = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   console.log(this.mainImagelist);
      //   this.selectGoodsArr = this.itemListFor;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListForFilter = newArr;
          this.selectGoodsFilterArr = newArr;
        }
      }
      this.selectGoodsStateFilter = false;
    },
    //选择商品数据
    selectGoodsCloseFilter1(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListForFilter1 = newArr;
          this.selectGoodsFilterArr1 = newArr;
        }
      }
      this.selectGoodsStateFilter1 = false;
    },
    //双订单指定选择商品数据
    selectGoodsCloseFilter5(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListForFilter5 = newArr;
          this.selectGoodsFilterArr5 = newArr;
        }
      }
      this.selectGoodsStateFilter5 = false;
    },
    //双订单排除选择商品数据
    selectGoodsCloseFilter6(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListForFilter6 = newArr;
          this.selectGoodsFilterArr6 = newArr;
        }
      }
      this.selectGoodsStateFilter6 = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (row.quantityTotal && row.price && row.prizeCount) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.prizeCount;
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      // e.target.value = Number(filtered);
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      console.log(row);
      if (this.isStartEdit) {
        if (row.minNum && Number(row.prizeCount) < Number(row.minNum)) {
          row.prizeCount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },

    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/.prize_box .el-table__body-wrapper {
  overflow: visible !important;
  // overflow: auto;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #2670fb;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #f8f9ff;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 16px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #2670fb;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    // padding-left: 18px;
    width: 90px;
    // background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    // background-size: 14px 14px;
    display: flex;
    align-items: center;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #2670fb;
  }
  color: #999;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fff;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .add_btn1 {
    cursor: pointer;
    color: #2670fb;
    border: 1px solid #2670fb;
    width: 132px;
    height: 32px;
    display: flex;
    border-radius: 4px;
    background: rgba(38, 112, 251, 0.1);
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    &:hover {
      background: #2670fb;
      color: #fff;
    }
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2670fb;
            border-bottom: 1px solid #2670fb;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2670fb;
            border-left: 1px solid #2670fb;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #2670fb;
                border-bottom: 1px solid #2670fb;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #2670fb;
                border-left: 1px solid #2670fb;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .icon-top {
      position: relative;
      z-index: 999;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}

// start
/deep/ .tableScopeSwitch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}
/*打开时文字位置设置*/
/deep/ .tableScopeSwitch .el-switch__label--right {
  z-index: 1;
  top: -1px;
  left: 0;
}
/*关闭时文字位置设置*/
/deep/ .tableScopeSwitch .el-switch__label--left {
  z-index: 1;
  top: -1px;
  right: 0;
}
/*显示文字*/
/deep/ .tableScopeSwitch .el-switch__label.is-active {
  display: block;
}
/deep/ .tableScopeSwitch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
}
/deep/ .el-switch__label * {
  font-size: 10px;
}
.flex-center {
  display: flex;
  align-items: center;
}
// end
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
/deep/ .custom {
  width: 500px;
}
</style>
